import { render, staticRenderFns } from "./AdditionalPrice.vue?vue&type=template&id=348f151e"
import script from "./AdditionalPrice.vue?vue&type=script&lang=ts"
export * from "./AdditionalPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports